import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-utileria',
  templateUrl: './spinner-utileria.component.html',
  styleUrls: ['./spinner-utileria.component.scss']
})
export class SpinnerUtileriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
